<div class="container-fluid p-0">
  <div id="app-market-guidelines">
    <div class="row">
      <h4>Choose a Market Type and Topic to gain more information.</h4>

      <div class="col-12 my-2">
        <label class="form-label">Market Type</label>
        <select
          (change)="marketGuideService.marketTypeChangeHandler($event)"
          class="form-select"
          aria-label="Service label"
        >
          <option value="" selected>-- select service type ---</option>
          @for (service of marketGuideService.marketTypeList; track service) {
            <option
              value="{{ service }}"
            >
              {{ service }}
            </option>
          }
        </select>
      </div>

      @if (marketGuideService.selectedMarketType) {
        <div
          [@inOutAnimation]
          class="col-12 my-2"
        >
        <label class="form-label">Topic</label>
        <select
          (change)="
            marketGuideService.selectTopicHandler($event); passValuesToParent()
          "
          class="form-select"
          aria-label="Topic label"
        >
          <option value="" selected>-- select topic --</option>
          @for (topic of marketGuideService.marketTopicList; track topic) {
            <option
              value="{{ topic }}"
            >
              {{ topic }}
            </option>
          }
        </select>
      </div>
    }

      @if (marketGuideService.selectedTopic) {
        <div
          [@inOutAnimation]
          class="col-12 my-2"
        >
        <div class="col-12 my-2">
          <h5 class="mt-3">Overview</h5>
          <p [innerHTML]="marketGuideService.overviewDescription"></p>
          <p>
            <a class="text-blue-600 underline hover:text-blue-800 cursor-pointer"
              target="_blank" href="{{ marketGuideService.overviewURL }}"
              >Learn more</a
            >
          </p>

        </div>

      </div>
    }
    </div>
  </div>
  <!-- <div class="row">
        <div [@inOutAnimation] *ngIf="marketGuideService.selectedTopic" class="col mt-3">
            <button (click)="previewPDFHandler()" class="btn btn-primary">Preview PDF</button>
        </div>
    </div> -->
</div>
